import { useTranslation } from "react-i18next";
import { LocalizedLink } from "@/i18n/language";
import { img } from "@/lib/images";

export default function KuebelwagenTile() {
  const { t } = useTranslation();

  const facts = ["kw_tile_fact_1", "kw_tile_fact_2", "kw_tile_fact_3"];

  return (
    <section className="py-14 md:py-20 bg-primary-700 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-6">
          <div className="eyebrow-brand text-xs md:text-sm uppercase tracking-[0.35em] mb-4">
            — {t("kw_tile_eyebrow")} —
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-[1.08] tracking-tight mb-6">
            {t("kw_tile_title")}
          </h2>
          <p className="text-background-200 text-base md:text-lg font-light leading-relaxed max-w-xl">
            {t("kw_tile_text")}
          </p>

          <div className="mt-7 flex flex-wrap gap-2.5">
            {facts.map((key) => (
              <span
                key={key}
                className="inline-flex items-center gap-2 rounded-full border border-background-50/25 px-4 py-1.5 text-xs md:text-sm text-background-100 whitespace-nowrap"
              >
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-400"></i>
                {t(key)}
              </span>
            ))}
          </div>

          <LocalizedLink
            to="/vw181-kuebelwagen"
            className="mt-9 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 btn-on-dark text-background-50 px-7 py-3.5 rounded-md font-semibold uppercase tracking-[0.12em] md:tracking-[0.18em] text-xs md:text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            {t("kw_tile_cta")}
            <i className="ri-arrow-right-line"></i>
          </LocalizedLink>
        </div>

        <div className="lg:col-span-6">
          <div className="relative rounded-lg overflow-hidden h-[280px] sm:h-[380px] lg:h-[440px] border border-background-50/15">
            <img
              src={img("balivwtour/vw181-kuebelwagen/vw181cars19.jpg")}
              alt={t("kw_img_1")}
              title="Bali VW Tour – VW 181 Kübelwagen"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}